<template>

    <div class="px-3 lg:px-9">
        <slot />
    </div>

</template>